export default () => {
  const burger = document.querySelector('.header__burger')
  const nav = document.querySelector('.header__nav')
  const header = document.querySelector('.header')

  burger.addEventListener('click', () => {
    nav.classList.toggle('opened')
  })

  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 20) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
  })
}
